/**
 * Liens OFFICIELS des applis Gively (source unique) — 06/10/2026.
 *
 * - App Store : App ID 6788333825 (App Store Connect, bundle fr.gively.app) ;
 *   version 1.3.5 en ligne (iTunes Lookup, 05/10/2026).
 * - Google Play : paquet com.gively.app (capacitor.config.json `appId`) ;
 *   fiche « Gively : Achetez, soutenez » vérifiée le 06/10/2026.
 *
 * Badges : artwork officiel, NON modifié (règles des deux marques) —
 * `public/badges/app-store.svg` = developer.apple.com/assets/elements/badges/
 * download-on-the-app-store.svg ; `public/badges/google-play-fr.png` =
 * play.google.com/intl/en_us/badges/static/images/badges/fr_badge_web_generic.png
 * (le PNG Google inclut sa marge transparente : 192 px d'artwork sur 250).
 */
export const APP_STORE_URL = "https://apps.apple.com/fr/app/gively-marketplace-solidaire/id6788333825";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.gively.app";
export const APP_STORE_ID = "6788333825";
// Paquet Android (capacitor.config.json `appId`). Le MÊME identifiant est déclaré
// dans public/manifest.json `related_applications` : c'est ce qui permet à
// `navigator.getInstalledRelatedApps()` (Chrome Android) de dire si l'appli est
// déjà installée — et à l'invitation de se taire dans ce cas (10/10/2026).
export const PLAY_PACKAGE_ID = "com.gively.app";
